import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ProductsActions} from '../store';
import {ProductsSelectors} from '../store/selectors';

@Injectable()
export class ProductsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadProductsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadProductsDone() {

    return this.store.pipe(
      select(ProductsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ProductsActions.ReadProducts());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
